<template>
  <div id="editar-contrato" dusk="editar-contrato">
    <h2 v-if="!loading && pendencias.existe_pendencias" class="text-danger">
      <vs-alert
        active="true"
        class="mt-5 mb-5"
        color="danger"
        icon-pack="feather"
        icon="icon-info"
      >Este contrato possui alguma(s) pendências que precisam ser resolvidas antes de envia-lo para análise.</vs-alert>
    </h2>
    <h2 v-if="!loading && situacao.status.id === 3 && anotacoes.length" class="text-danger">
      <vs-alert
        active="true"
        class="mt-5 mb-5"
        color="warning"
        icon-pack="feather"
        icon="icon-info"
      >Contrato pendente pelo motivo: {{ anotacoes[anotacoes.length-1].anotacao }}</vs-alert>
    </h2>
    <contrato-form-placeholder v-if="loading" />
    <div v-show="!loading">
      <div class="vx-row">
        <vs-col vs-lg="8" vs-md="6" vs-sm="12">
          <vs-tabs v-model="tabAtual">
            <vs-tab label="Informações" icon="people">
              <vx-card
                ref="dadosPessoaisCard"
                title="Dados pessoais"
                subtitle="Preencha corretamente os dados pessoais do cliente."
                cardBorder
                noShadow
              >
                <editar-dados-pessoais ref="dadosPessoaisRef" v-model="cliente"></editar-dados-pessoais>
              </vx-card>

              <vx-card
                ref="enderecosCard"
                title="Endereços"
                subtitle="Preencha corretamente o endereço do cliente."
                cardBorder
                noShadow
              >
                <div
                  class="editar-endereco-container"
                  v-for="(endereco, index) in enderecos"
                  v-bind:key="endereco.id"
                >
                  <editar-endereco ref="enderecosRef" v-model="enderecos[index]"></editar-endereco>
                </div>
              </vx-card>

              <vx-card
                ref="telefonesCard"
                title="Telefones"
                subtitle="Preencha corretamente o telefone do cliente."
                cardBorder
                noShadow
              >
                <div
                  class="editar-telefone-container"
                  v-for="(telefone, index) in telefones"
                  v-bind:key="telefone.id"
                >
                  <editar-telefone ref="telefonesRef" v-model="telefones[index]"></editar-telefone>
                </div>
              </vx-card>
              <vx-card
                   ref="anotacoesCard"
                title="Anotações"
                subtitle="Quando necessário, você pode adicionar anotações do contrato."
                cardBorder
                noShadow
              >
              <editar-anotacoes></editar-anotacoes>
              </vx-card>
            </vs-tab>

            <vs-tab label="Documentos" icon="attach_file">
              <editar-documentos :contrato="desconto" :pendencias="pendencias"></editar-documentos>
            </vs-tab>

            <vs-tab label="Anotações" icon="speaker_notes">
              <vx-card
                title="Anotações"
                subtitle="Quando necessário, você pode adicionar anotações do contrato."
                cardBorder
                noShadow
              >
                <editar-anotacoes></editar-anotacoes>
              </vx-card>
            </vs-tab>
          </vs-tabs>
        </vs-col>

        <vs-col vs-lg="4" vs-md="6" vs-sm="12" class="vx-col mb-4 padding-sidebar-contrato">
          <div class="vx-row">
            <!-- Codigo -->
            <vs-col vs-w="12" class="vx-col mb-6">
              <vx-card class="vx-card-white" cardBorder noShadow>
                <div class="flex justify-between">
                  <div class="flex justify-between mr-5 flex-col">
                    <div class="mb-4">
                      <h4>Autenticador</h4>
                      <p>código autenticador para os documentos</p>
                    </div>
                    <h1 class="text-danger">{{ desconto.codigo }}</h1>
                  </div>
                  <div class="flex self-center">
                    <qrcode value="desconto.codigo" :options="{ width: 80, margin: 0 }" />
                  </div>
                </div>
              </vx-card>
            </vs-col>
            <!-- Codigo -->

            <!-- Situação do contrato -->
            <vs-col vs-w="12" class="vx-col mb-6">
              <vx-card
                ref="situacaoDescontoCard"
                title="Situação do contrato"
                cardBorder
                noShadow
                class="vx-card-green"
              >
                <editar-situacao-contrato ref="situacaoDescontoRef" v-model="situacao"></editar-situacao-contrato>
              </vx-card>
            </vs-col>
            <!-- Situação do contrato -->

            <!-- Cobrança -->
            <vs-col vs-w="12" class="vx-col mb-6">
              <vx-card ref="descontoCard" title="Cobrança" cardBorder noShadow class="vx-card-blue">
                <editar-cobranca-inss
                  v-if="desconto.associacao"
                  ref="cobrancaInssRef"
                  v-model="desconto"
                ></editar-cobranca-inss>
              </vx-card>
            </vs-col>
            <!-- Cobrança -->

            <!-- Salvar contrato -->
            <div class="faixa-white" v-if="tabAtual == 0">
              <vs-button
                @click="$router.push('/contratos')"
                type="border"
                color="dark"
                size="large"
                class="btn-float font-bold mr-2"
              >Fechar</vs-button>
              <vs-button
                @click="salvarDesconto"
                type="relief"
                size="large"
                class="btn-float font-bold"
              >
                <feather-icon class="align-middle inline-block mr-2" icon="SaveIcon" />Salvar Contrato
              </vs-button>
            </div>
            <!-- Salvar contrato -->
          </div>
        </vs-col>
      </div>
    </div>
  </div>
</template>

<script>
import EditarDadosPessoais from "./components/EditarDadosPessoais.vue";
import EditarEndereco from "./components/EditarEndereco.vue";
import EditarTelefone from "./components/EditarTelefone.vue";
import EditarDocumentos from "./components/EditarDocumentos.vue";
import EditarAnotacoes from "./components/EditarAnotacoes.vue";
import EditarSituacaoContrato from "./components/EditarSituacaoContrato.vue";
import EditarCobrancaInss from "./components/EditarCobrancaInss.vue";
import queryParams from "@services/repository-service";
import api from "@services/api-service";
import ContratoFormPlaceholder from "@/components/placeholders/ContratoFormPlaceholder";

export default {
  components: {
    EditarDadosPessoais,
    EditarEndereco,
    EditarTelefone,
    EditarDocumentos,
    EditarAnotacoes,
    EditarSituacaoContrato,
    EditarCobrancaInss,
    ContratoFormPlaceholder
  },
  provide() {
    return {
      $validator: this.$validator
    };
  },
  data() {
    return {
      // todo:  Pensar em como salvar os dados ao mudar tabs.
      //        No momento o botao salvar fica oculto quando
      //        o usuario esta em um tab diferente de informacoes.
      tabAtual: 0,
      pendencias: {},
      desconto: {
        beneficio: {}
      },
      anotacoes: {},
      cliente: {},
      enderecos: [{}],
      telefones: [{}],
      situacao: {},
      loading: false
    };
  },
  mounted() {
    this.loading = true;
    setTimeout(async () => {
      await this.buscarDesconto();
      await this.buscarPendencias();

      this.$socket
        .channel(`Contrato.${this.desconto.id}`)
        .listen(".PendenciasAtualizadas", this.buscarPendencias)
        .listen(".ContratoAtualizado", this.atualizarContratoSocket);

      this.loading = false;
    }, 100);
  },
  watch: {
    loading(loading) {
      if (!this.$refs.dadosPessoaisCard) return;

      const cards = [
        this.$refs.dadosPessoaisCard,
        this.$refs.enderecosCard,
        this.$refs.telefonesCard,
        this.$refs.descontoCard,
        this.$refs.situacaoDescontoCard
      ];

      if (loading) {
        cards.map(card => card.refreshcard());
      } else {
        cards.map(card => card.removeRefreshAnimation());
      }
    }
  },
  methods: {
    async buscarDesconto() {
      try {
        const response = await api().get(`contratos/${this.$route.params.id}`, {
          params: queryParams({
            relationships: [
              "status",
              "statusMotivo",
              "cliente",
              "associacao",
              "entidade",
              "formaPagamento",
              "cliente.sexo",
              "cliente.estadoCivil",
              "cliente.enderecos",
              "cliente.enderecos.estado",
              "contratoAnotacao",
              "cliente.telefones",
              "beneficio.especieBeneficio",
              "porcentagemDesconto",
              "beneficio",
              "tipoContrato"
            ]
          })
        });

        if (response.data.status) {
          this.desconto = response.data.data;
          this.cliente = this.desconto.cliente;
          this.anotacoes = this.desconto.contratoAnotacao;
          this.situacao = {
            id: this.desconto.id,
            status: this.desconto.status,
            statusMotivo: this.desconto.statusMotivo
          };

          if (this.cliente.enderecos.length > 0) {
            this.enderecos = this.cliente.enderecos;
          }

          if (this.cliente.telefones.length > 0) {
            this.telefones = this.cliente.telefones;
          }
        }
      } catch (error) {
        //
      }
    },
    async buscarPendencias() {
      try {
        const response = await api().get(
          `/contratos/${this.desconto.id}/pendencias`
        );

        this.pendencias = response.data.data;
      } catch (error) {
        // ...
      }
    },
    async salvarDesconto() {
      try {
        await this.validarFormulario();

        this.loading = true;

        // SALVAR CLIENTE
        let clienteResponse = await api().put(
          `clientes/${this.cliente.id}`,
          this.cliente
        );

        if (!clienteResponse.data.status)
          throw Error("Ocorreu um erro ao cadastrar desconto.");

        this.cliente.id = clienteResponse.data.data.id;

        // SALVAR ENDERECOS
        this.enderecos.map(async endereco => {
          endereco.cliente_id = this.cliente.id;

          let enderecoResponse = {};

          if (endereco.id) {
            enderecoResponse = await api().put(
              `cliente-endereco/${endereco.id}`,
              endereco
            );
          } else {
            enderecoResponse = await api().post(`cliente-endereco`, endereco);
          }

          if (!enderecoResponse.data.status)
            throw Error("Ocorreu um erro ao cadastrar desconto.");
        });

        // SALVAR TELEFONES
        this.telefones.map(async telefone => {
          telefone.cliente_id = this.cliente.id;
          let telefoneResponse = await api().put(
            `cliente-telefone/${telefone.id}`,
            telefone
          );

          if (!telefoneResponse.data.status)
            throw Error("Ocorreu um erro ao cadastrar desconto.");
        });

        // SALVAR BENEFICIO
        this.desconto.beneficio.cliente_id = this.cliente.id;
        let beneficioResponse = await api().put(
          `beneficios/${this.desconto.beneficio.id}`,
          this.desconto.beneficio
        );

        if (!beneficioResponse.data.status)
          throw Error("Ocorreu um erro ao cadastrar desconto.");

        this.desconto = {
          ...this.desconto,
          beneficio_id: beneficioResponse.data.data.id,
          beneficio: {
            ...this.desconto.beneficio,
            id: beneficioResponse.data.data.id
          }
        };

        // SALVAR DESCONTO
        this.desconto.cliente_id = this.cliente.id;

        const descontoResponse = await api().put(
          `contratos/${this.desconto.id}`,
          {
            ...this.desconto,
            ...this.situacao
          }
        );

        if (!descontoResponse.data.status)
          throw Error("Ocorreu um erro ao cadastrar desconto.");

        this.alertaSucesso("Contrato atualizado com sucesso.");
      } catch (error) {
        this.alertaErro(error.message);
      }

      this.loading = false;
    },
    atualizarContratoSocket({ data }) {
      this.desconto = this.$plugins.deepMerge(this.desconto, data);
    },
    validarFormulario() {
      const formularios = [
        this.$refs.dadosPessoaisRef,
        ...this.$refs.enderecosRef,
        ...this.$refs.telefonesRef,
        this.$refs.situacaoDescontoRef,
        this.$refs.cobrancaInssRef
      ];

      return Promise.all(
        formularios.map(async function(child) {
          const valido = await child.$validator.validateAll();
          if (!valido) {
            switch (child.$options.name) {
              case "editar-dados-pessoais":
                throw Error("Complete os dados pessoais do cliente.");
              case "editar-endereco":
                throw Error("Complete o endereço do cliente.");
              case "editar-telefone":
                throw Error("Complete o telefone do cliente.");
              case "editar-situacao-desconto":
                throw Error(
                  "Informe a situação do contrato e motivo se necessário."
                );
              case "editar-cobranca-inss":
                throw Error("Complete os dados de cobrança.");
              default:
                throw Error();
            }
          }
        })
      );
    },
    alertaSucesso(text) {
      this.$vs.notify({
        title: "Sucesso!",
        text: text,
        color: "success",
        iconPack: "feather",
        icon: "icon-check",
        position: "bottom-center"
      });
    },
    alertaErro(text) {
      this.$vs.notify({
        title: "Erro.",
        text: text,
        color: "danger",
        iconPack: "feather",
        icon: "icon-alert-circle",
        position: "bottom-center",
        time: 10000
      });
    }
  }
};
</script>



